import { Group } from '@reliance/types/models/MobileDevice/Group';
import { IApiService, IPaginatedResponse } from '../services/api_service';

export const mobileDevice = (siteApi: IApiService) => ({
  index: (orderBy) => {
    return siteApi.get('/mobile-device', {
      params: {
        includeInmates: true,
        orderBy,
        applications: 'Connect - Messaging',
        perPage: 1000
      }
    });
  },
  getAvailable: () => {
    return siteApi.get('/mobile-device', {
      params: {
        excludeInmateAssigned: true,
        orderBy: 'name',
        applications: 'Connect - Messaging',
        perPage: 1000
      }
    });
  },
  resetAppLock: (ids) => {
    return siteApi.put(`/mobile-device/${ids.join(',')}/reset-app-lock`);
  },
  put: (ids, data) => {
    return siteApi.put(`/mobile-device/${ids.join(',')}`, data);
  },
  group: {
    index: (params = {}): Promise<IPaginatedResponse<Group>> => {
      return siteApi.get('/mobile-device/group', { params });
    }
  }
});
